import BossModel from "@/models/BossModel";
import City from "@/models/City/City";

export default class Airport extends BossModel {
    declare id: number;
    declare code: string;
    declare city_id: number;
    declare label: string;
    declare url: string;
    declare name: string;
    declare icao: string;
    declare lat: number;
    declare lng: number;
    declare alternatenames: string;
    declare gmt: string;
    declare tch_code: string;
    declare phone: string;
    declare website: string;
    declare geoname_eid: string;
    declare is_active: boolean;
    declare city: City | null;

    /**
     *
     * @type {string}
     */
    static apiUrl = "airport";

    /**
     *
     * @type {string}
     */
    static entity = "airports";

    static fields() {
        return {
            id: this.number(null).nullable(),
            code: this.attr(null),
            city_id: this.number(null).nullable(),
            label: this.attr(null),
            url: this.attr(null),
            name: this.attr(null),
            icao: this.attr(null),
            lat: this.number(null).nullable(),
            lng: this.number(null).nullable(),
            alternatenames: this.attr(null),
            gmt: this.attr(null),
            tch_code: this.attr(null),
            phone: this.attr(null),
            website: this.attr(null),
            geoname_eid: this.attr(null),
            is_active: this.boolean(null),
            city: this.belongsTo(City, "city_id"),
        };
    }

    /**
     *
     * @param params
     * @returns {*}
     */
    static search(params = { filters: {} }) {
        return this.api()
            .filtered(params.filters)
            .get()
            .then((data) => {
                const instances = [];
                for (const key in data) {
                    instances.push(new Airport(data[key]));
                }
                return instances;
            });
    }

    /**
     *
     * @returns {boolean|*}
     */
    City() {
        return this.getRelated("city");
    }
}
